import Vue from 'vue'
import VueRouter from 'vue-router'
import routerConfig from '@/config/router'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: routerConfig.mode,
  base: '/user/',
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/user/views/Login.vue'),
    },
    

    {
      path: '/home',
      name: 'Home',
      component: () => import('@/pages/user/views/Home.vue'),
    },
    {
      path: '/home/:shareToken',
      name: 'Home',
      component: () => import('@/pages/user/views/Home.vue'),
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () => import('@/pages/user/views/Profile.vue'),
    },
    {
      path: '/account',
      name: 'Account',
      component: () => import('@/pages/user/views/Account.vue'),
    },
    {
      path: '/deposit',
      name: 'Deposit',
      component: () => import('@/pages/user/views/Deposit.vue'),
    },
    {
      path: '/withdraw',
      name: 'Withdraw',
      component: () => import('@/pages/user/views/Withdraw.vue'),
    },
    {
      path: '/menu',
      name: 'Menu',
      component: () => import('@/pages/user/views/Menu.vue'),
    },
    {
      path: '/game',
      name: 'Game',
      component: () => import('@/pages/user/views/Game.vue'),
    },
    {
      path: '/game/:category',
      name: 'Game',
      component: () => import('@/pages/user/views/Game.vue'),
    },
    {
      path: '/spinner',
      name: 'Spinner',
      component: () => import('@/pages/user/views/Spinner.vue'),
    },
    {
      path: '/transactions',
      name: 'Transactions',
      component: () => import('@/pages/user/views/Transactions.vue'),
    },
    {
      path: '/cash_back', 
      name: 'Rolling', 
      component: () => import('@/pages/user/views/Rolling.vue'),
    },
    {
      path: '/free_credit',
      name: 'FreeCreadit',
      component: () => import('@/pages/user/views/FreeCreadit.vue'),
    },

    {
      path: '/affiliate',
      name: 'Affiliate',
      component: () => import('@/pages/user/views/Affiliate.vue'),
    },
    {
      path: '/promotion',
      name: 'Promotion',
      component: () => import('@/pages/user/views/Promotion.vue'),
    },
    {
      path: '/history',
      name: 'History',
      component: () => import('@/pages/user/views/History.vue'),
    },
    {
      path: '/slot',
      name: 'Slots',
      component: () => import('@/pages/user/views/Slots.vue'),
    },
    {
      path: '/baccarat',
      name: 'Casino',
      component: () => import('@/pages/user/views/Casino.vue'),
    },
    {
      path: '/poker',
      name: 'Poker',
      component: () => import('@/pages/user/views/Poker.vue'),
    },
    {
      path: '/trading',
      name: 'Trading',
      component: () => import('@/pages/user/views/Trading.vue'),
    },
    {
      path: '/transactions-withdraw',
      name: 'TransactionsWithdraw',
      component: () => import('@/pages/user/views/TransactionsWithdraw.vue'),
    },
    {
      path: '/transactions-deposit',
      name: 'TransactionsDeposit',
      component: () => import('@/pages/user/views/TransactionsDeposit.vue'),
    },
    {
      path: '*',
      name: '404 Not Found',
      beforeEnter: () => {
        window.location.href = '/user/home'
      },
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  if (to.path === '/') {
    next('/profile')
    return
  }
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  if (requiresAuth) {
    next()
    return
  } else {
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/pages/user/router/index.js